'use strict';

exports.__esModule = true;
exports.Type = exports.Definition = undefined;

var _Definition = require('./Definition');

var _Definition2 = _interopRequireDefault(_Definition);

var _Type = require('./Type');

var _Type2 = _interopRequireDefault(_Type);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Definition = _Definition2.default;
exports.Type = _Type2.default;


//////////////////
// WEBPACK FOOTER
// ./~/kindergarten/lib/rules/index.js
// module id = wzr5
// module chunks = 0